import { render, staticRenderFns } from "./CardComment.vue?vue&type=template&id=5384dd54&"
import script from "./CardComment.vue?vue&type=script&lang=js&"
export * from "./CardComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports